module.exports = __webpack_public_path__ + "img/2.f727a784.jpg";